import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {observer, inject} from 'mobx-react'
import {Row, Col, Radio, Checkbox, Tooltip, Glyphicon, OverlayTrigger, Button} from 'react-bootstrap'
import Reorder from 'react-reorder'
import Logger from '../stores/Logger'
import SlideListItem from '../containers/SlideListItem'
import '../containers/css/PresentIdeaOptions.css'
import * as helpers from '../lib/HelperFunctions'
import VideoModal from '../components/VideoModal'

const SLIDE_NAMES =
    {intro: 'Introduction',
    team: 'Originator & Co-creators',
    need: 'Need/problem of an idea',
    images: 'Image slide',
    recommendation: 'Recommendation slide',
    stages: 'Idea stages',
    sketch: 'Sketch',
    richText: 'More text',
    timeline: 'Timeline',
    viability: 'Economic Viability',
    outro: 'Thank you'}

class PresentIdeaOptions extends Component {

    constructor(props) {
        super(props)
        this.changeColors = this.changeColors.bind(this)
        this.displayQuestions = this.displayQuestions.bind(this)
        this.itemDragged = this.itemDragged.bind(this)
        this.state = {
            existingIdeaKey: undefined,
            check: undefined,
        }
    }

    componentWillMount(){
        // console.log('componentWillMount')
        const {stores} = this.props
        const {store, authStore} = stores

        if (this.props.params.ideaKey){
            // console.log('got idea key:',this.props.params.ideaKey, ', old one was:',this.state.existingIdeaKey)
            this.unwatchAuth = authStore.watchAuth(user => {
                if (user){
                    store.loadIdeaWithKey(this.props.params.ideaKey)
                    this.setState({existingIdeaKey: this.props.params.ideaKey})
                }
            }, error => {
                console.log('watchAuth error: '+JSON.stringify(error))
            })
        }
    }

    displayQuestions(isEnabled){
        let checkMark = null
        if(isEnabled === true){
            checkMark = false
        }
        else{
            checkMark = true
        }
        this.props.stores.store.updateIdeaProp(
                this.props.params.ideaKey,
                'showQuestions',
                checkMark,
        )
    }

    changeCheck(e, showQuestions){
        this.setState({check: showQuestions})
    }

    changeColors(colorArray, number){
        var whichColor = ['slideBgColor', 'slideHeaderColor', 'slideTextColor']
        for (var i = 0; i < colorArray.length; i++) {
            this.props.stores.store.updateIdeaProp(
                this.props.params.ideaKey,
                whichColor[i],
                colorArray[i],
            )
        }
        this.props.stores.store.updateIdeaProp(
            this.props.params.ideaKey,
            'whichTemplate',
            number,
        )
    }

    itemDragged(event, item, index, newIndex, list) {
        this.props.stores.store.updateSlideSettings(list, this.props.params.ideaKey)
        Logger.trackEvent('presentOptionsItemDragged')
    }

    onReset(){
        this.props.stores.store.updateSlideSettings(this.props.stores.store.defaultSlides, this.props.params.ideaKey)
        Logger.trackEvent('presentOptionsReset')
    }

    goBack() {
        // console.log('doClose')
        const {stores} = this.props
        const {routingStore} = stores

        window.onpopstate = null

        const { goBack } = routingStore
        goBack()
    }

    render() {
        const {stores} = this.props
        const {store, routingStore, authStore, toolStore} = stores
        const {theIdea, theIdeaStatus} = store
        const {push, location} = routingStore
        var theUser = authStore.authUser()

        if(theIdeaStatus===0){
            return null
        }else if(theIdeaStatus===403){
            Logger.trackEvent('403', location.pathname, helpers.mangleEmail(theUser.email))
            window.onpopstate = null
            push('/forbidden')
            return null
        }else if(theIdeaStatus===404){
            Logger.trackEvent('404', location.pathname, helpers.mangleEmail(theUser.email))
            window.onpopstate = null
            push('/notfound')
            return null
        }else if(theIdeaStatus===500){
            window.onpopstate = null
            push('/error')
            return null
        }

        const resetTip = (<Tooltip id='reset'><strong>Reset to default</strong></Tooltip>)
        let local = JSON.parse(JSON.stringify(theIdea.slides))

        let slide_names = SLIDE_NAMES
        for(let t of toolStore.toolOrder){
            slide_names[t] = toolStore.allToolShowNames[t]
        }

         for (var j = 0; j < local.length; j++){
            local[j].number = j
            local[j].text = slide_names[local[j].name]
            if(local[j].name==='valueTool') //FIXME: SILLY SILLY SILLY HACK
                local[j].text = toolStore.allToolShowNames['valueCreationTool']
            local[j].key = this.props.params.ideaKey
        }

        return (
            <Row className='pageContainer'>
                <Col lg={6} md={6} sm={12} xs={12} className='pickerContainer'>
                    <h1 style={{margin: 0}}>Presentation theme
                         <span>
                            <VideoModal
                                 videoTitle='Rate your idea'
                                 videoURL='https://www.youtube.com/watch?v=tXT1hX6y4ls'
                            />
                         </span>
                    </h1>
                    <span>Change the style of presentation slides</span>
                    <div>
                        <div style={{display: 'inline-block'}}>
                            <div>
                                <Radio
                                    onClick={() => this.changeColors(this.props.templateOriginal, 1)}
                                    checked={theIdea.whichTemplate === 1}
                                    name='radioGroup'
                                    readOnly
                                    style={{verticalAlign: 'middle', display: 'inline-block'}}
                                />
                                <h3 style={{display: 'inline-block'}}>Original</h3>
                                <div className='optionsTemplate' onClick={() => this.changeColors(this.props.templateOriginal, 1)}>
                                    <div style={{backgroundColor: this.props.templateOriginal[0]}} className='templateBg'></div>
                                    <div style={{backgroundColor: this.props.templateOriginal[1]}} className='templateHeader'></div>
                                    <div style={{backgroundColor: this.props.templateOriginal[2]}} className='templateText'></div>
                                </div>
                            </div>

                            <div>
                                <Radio
                                    onClick={() => this.changeColors(this.props.templatePlayful, 2)}
                                    checked={theIdea.whichTemplate === 2}
                                    name='radioGroup'
                                    readOnly
                                    style={{verticalAlign: 'middle', display: 'inline-block'}}
                                />
                                <h3 style={{display: 'inline-block'}}>Playful</h3>
                                <div className='optionsTemplate' onClick={() => this.changeColors(this.props.templatePlayful, 2)}>
                                    <div style={{backgroundColor: this.props.templatePlayful[0]}} className='templateBg'></div>
                                    <div style={{backgroundColor: this.props.templatePlayful[1]}} className='templateHeader'></div>
                                    <div style={{backgroundColor: this.props.templatePlayful[2]}} className='templateText'></div>
                                </div>
                            </div>

                            <div>
                                <Radio
                                    onClick={() => this.changeColors(this.props.templateCorporate, 3)}
                                    checked={theIdea.whichTemplate === 3}
                                    name='radioGroup'
                                    readOnly
                                    style={{verticalAlign: 'middle', display: 'inline-block'}}
                                />
                                <h3 style={{display: 'inline-block'}}>Corporate</h3>
                                <div className='optionsTemplate' onClick={() => this.changeColors(this.props.templateCorporate, 3)}>
                                    <div style={{backgroundColor: this.props.templateCorporate[0]}} className='templateBg'></div>
                                    <div style={{backgroundColor: this.props.templateCorporate[1]}} className='templateHeader'></div>
                                    <div style={{backgroundColor: this.props.templateCorporate[2]}} className='templateText'></div>
                                </div>
                            </div>
                        </div>
                        <div className='presentIdeaSecondRowColors'>
                            <div>
                                <Radio
                                    onClick={() => this.changeColors(this.props.templateFancy, 4)}
                                    checked={theIdea.whichTemplate === 4}
                                    name='radioGroup'
                                    readOnly
                                    style={{verticalAlign: 'middle', display: 'inline-block'}}
                                />
                                <h3 style={{display: 'inline-block'}}>Fancy</h3>
                                <div className='optionsTemplate' onClick={() => this.changeColors(this.props.templateFancy, 4)}>
                                    <div style={{backgroundColor: this.props.templateFancy[0]}} className='templateBg'></div>
                                    <div style={{backgroundColor: this.props.templateFancy[1]}} className='templateHeader'></div>
                                    <div style={{backgroundColor: this.props.templateFancy[2]}} className='templateText'></div>
                                </div>
                            </div>

                            <div>
                                <Radio
                                    onClick={() => this.changeColors(this.props.templateLight, 5)}
                                    checked={theIdea.whichTemplate === 5}
                                    name='radioGroup'
                                    readOnly
                                    style={{verticalAlign: 'middle', display: 'inline-block'}}
                                />
                                <h3 style={{display: 'inline-block'}}>Light</h3>
                                <div className='optionsTemplate' onClick={() => this.changeColors(this.props.templateLight, 5)}>
                                    <div style={{backgroundColor: this.props.templateLight[0]}} className='templateBg'></div>
                                    <div style={{backgroundColor: this.props.templateLight[1]}} className='templateHeader'></div>
                                    <div style={{backgroundColor: this.props.templateLight[2]}} className='templateText'></div>
                                </div>
                            </div>

                            <div>
                                <Radio
                                    onClick={() => this.changeColors(this.props.templateAutumn, 6)}
                                    checked={theIdea.whichTemplate === 6}
                                    name='radioGroup'
                                    readOnly
                                    style={{verticalAlign: 'middle', display: 'inline-block'}}
                                />
                                <h3 style={{display: 'inline-block'}}>Autumn</h3>
                                <div className='optionsTemplate' onClick={() => this.changeColors(this.props.templateAutumn, 6)}>
                                    <div style={{backgroundColor: this.props.templateAutumn[0]}} className='templateBg'></div>
                                    <div style={{backgroundColor: this.props.templateAutumn[1]}} className='templateHeader'></div>
                                    <div style={{backgroundColor: this.props.templateAutumn[2]}} className='templateText'></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg={6} md={6} sm={12} xs={12} style={{backgroundColor: theIdea.slideBgColor}} className='displayContainer'>
                    <div>
                        <p style={{color: theIdea.slideHeaderColor}} className='displayHeader'>Header</p>
                        {theIdea.showQuestions &&
                        <div style={{color: theIdea.slideTextColor}} className='displayTextQuestion'><strong>Question text</strong></div>
                        }
                        <div style={{color: theIdea.slideTextColor}} className='displayText'>Example text</div>
                    </div>
                </Col>
                <Col style={{float: 'right', marginBottom: 35+'px'}} lg={6} md={6} xs={12}>
                    <div style={{marginRight: 30+'px', display: 'inline-block'}}>
                        <Checkbox
                            key={'slideEnable'}
                            onClick={() => this.displayQuestions(theIdea.showQuestions)}
                            onChange={(e) => this.changeCheck(e, theIdea.showQuestions)}
                            checked={theIdea.showQuestions}
                            style={{position: 'relative', margin: 6, paddingBottom: 25+'px', verticalAlign: 'middle'}}
                            inline>
                        </Checkbox>
                        <span>Include questions for each tool question.</span>
                    </div>
                </Col>
                <Col style={{float: 'left', marginBottom: 55+'px'}} lg={6} md={6} xs={12}>
                    <div style={{marginRight: 30+'px', display: 'inline-block'}}>
                    <h1 className='slideOrderText'>Slide order</h1>
                    <OverlayTrigger placement='right' overlay={resetTip}>
                        <Button className='buttonReset' bsStyle='link' onClick={this.onReset.bind(this)}>
                            <Glyphicon glyph='refresh' className='resetWhiteIcon'/>
                        </Button>
                    </OverlayTrigger>
                    <p className='orderListDescription'>Click and drag slides to reorder presentation flow. Click checkbox to enable/disable slides.</p>
                        <Reorder
                            reorderId='my-list'
                            mouseHoldTime={100}
                            list={local}
                            callback={this.itemDragged}
                            holdTime={100}
                            itemKey={'number'}
                            template={SlideListItem}
                            disableReorder={false}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}

PresentIdeaOptions.propTypes = {
    templateLight: PropTypes.array,
    templateOriginal: PropTypes.array,
    templateCorporate: PropTypes.array,
    templateFancy: PropTypes.array,
    templatePlayful: PropTypes.array,
    templateAutumn: PropTypes.array,
}
PresentIdeaOptions.defaultProps = {
    templateLight: ['#ffffff', '#31394d', '#31394d'],
    templateOriginal: ['#1B1B18', '#ED1558', '#F5F1EB'],
    templateCorporate: ['#2c3345', '#ffffff', '#dddddd'],
    templateFancy: ['#ffffff', '#d13076', '#5587a2'],
    templatePlayful: ['#ffffff', '#008975', '#ff5572'],
    templateAutumn: ['#fcf7e4', '#b61d1d', '#444444'],
}

export default inject("stores")(observer(PresentIdeaOptions))



// WEBPACK FOOTER //
// ./src/containers/PresentIdeaOptions.js